import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import customizableComponent from '../../../core/hocs/customization';
import useChatInfo from '../../../chat/hooks/useChatInfo';
import useChannel from '../../../chat/hooks/useChannel';
import UserAvatar from '../../../chat/components/UserAvatar';
import { backgroundImage as communityBackgroundImage } from '../../../icons/Community';
import ChatDetailsControls from './ChatDetailsControls';
import ChatDetailsMembers from './ChatDetailsMembers';
import { ChatDetailsContainer, ChatDetailsHeader, HeaderCloseIcon, ChatDetailsTitle, TitleInfo, TitleInfoLabel, TitleInfoChatName, } from './styles';
const ChatDetails = ({ channelId, onClose, leaveChat, onEditChatMemberClick, onMemberSelect }) => {
    const channel = useChannel(channelId);
    const { chatName, chatAvatar } = useChatInfo({ channel });
    const [shouldShowMembers, setShouldShowMembers] = useState(false);
    return (React.createElement(ChatDetailsContainer, null,
        React.createElement(ChatDetailsHeader, null,
            React.createElement(FormattedMessage, { id: "chat.details.header" }),
            React.createElement(HeaderCloseIcon, { onClick: onClose })),
        React.createElement(ChatDetailsTitle, null,
            React.createElement(UserAvatar, { avatarUrl: chatAvatar, defaultImage: communityBackgroundImage }),
            React.createElement(TitleInfo, null,
                React.createElement(TitleInfoLabel, null,
                    React.createElement(FormattedMessage, { id: "chat.details.chatName" })),
                React.createElement(TitleInfoChatName, null, chatName))),
        shouldShowMembers ? (React.createElement(ChatDetailsMembers, { channelId: channelId, hideMembers: () => setShouldShowMembers(false), onMemberSelect: onMemberSelect, onEditChatMemberClick: onEditChatMemberClick })) : (React.createElement(ChatDetailsControls, { channelId: channelId, chatName: chatName, leaveChat: leaveChat, memberCount: channel.memberCount, showMembers: () => setShouldShowMembers(true) }))));
};
export default customizableComponent('ChatDetails', ChatDetails);
//# sourceMappingURL=index.js.map